export const MSG_TITLE = 'TRM Configuration';
export const SUCCESS_MSG =
  'The TRM system configurations have been saved successfully!';
export const FAILURE_MSG =
  'The TRM configuration fetch or update was failed. Please try again.';
export const CONFKEY_LABEL_MAP = {
  TDSS_BASE_URL: 'Pipeline Base Url',
  TDSS_CREDENTIAL_TOKEN: 'Pipeline Credential',
  TDSS_EXECUTION_ROUTE: 'Pipeline Execution Route',
  RUN_INSTANCE_PIPELINE_ID: 'Run Instance Pipeline Id',
  TDSS_PIPELINE_INSTANCE_STATUS_ROUTE: 'Pipeline Status Route',
  TDSS_PRODUCT_ID: 'Pipeline Product Id',
  TRAINING_PIPELINE_ID: 'Training Pipeline Id',
  PREDICTION_INSTANCE_PIPELINE_ID: 'Prediction Pipeline Id'
};
